import {ReactComponent as ShoppingBasketIcon} from './shoppingBasket.svg'

function ShoppingBasket() {
  return <ShoppingBasketIcon />
}

export default ShoppingBasket
